// 确认订单完成
import { AxiosEsb } from '../../../utils';

export default function confirmOrderDone(order_no) {
    let axios = AxiosEsb();
    return axios.post("api/sap/finishContract", {
        order_no,
    }).then(result => {
        if (result.data.status === true) {
            return result.data.msg;
        } else {
            return Promise.reject(result.data.msg);
        }
    });
}